import { useMemo } from 'react'

import Link from 'next/link'

import type { BannerItem as HomeMiddleBanner } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'

import ImageOptimize from '../ImageOptimize'

interface Props {
  banner: Array<HomeMiddleBanner>
  layout?: number | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any
}

const HomeBanner = ({ banner, layout }: Props) => {
  const layoutOne = useMemo(() => {
    return (
      <div className='mb-6 grid w-full grid-cols-3 gap-5'>
        {banner &&
          banner.slice(0, 2).map((e, index) => (
            <div className='' key={index}>
              <Link
                href={e.link || '/'}
                className='block h-full w-full overflow-hidden rounded outline-none'
              >
                <ImageOptimize
                  src={e.image}
                  alt={getTranslate(e.title)}
                  className='h-auto w-full object-cover'
                  loading='lazy'
                />
              </Link>
            </div>
          ))}
        <div className='flex flex-wrap content-between'>
          {banner &&
            banner.slice(2, 4).map((e, index) => (
              <div className='block' key={index}>
                <Link
                  href={e.link || '/'}
                  className='block h-full w-full overflow-hidden rounded outline-none'
                >
                  <ImageOptimize
                    src={e.image}
                    alt={getTranslate(e.title)}
                    className='h-auto w-full object-cover'
                    loading='lazy'
                  />
                </Link>
              </div>
            ))}
        </div>
      </div>
    )
  }, [layout])

  const layoutTwo = useMemo(() => {
    return (
      <div className='grid grid-cols-2 gap-[14px]'>
        {banner &&
          banner.map((e, index) => (
            <div className='w-full' key={index}>
              <Link
                href={e.link || '/'}
                className='block h-full w-full overflow-hidden rounded outline-none'
              >
                <ImageOptimize
                  src={e.image}
                  alt={getTranslate(e.title)}
                  className='h-full w-full object-cover'
                  loading='lazy'
                />
              </Link>
            </div>
          ))}
      </div>
    )
  }, [layout])

  const layoutThree = useMemo(() => {
    return (
      <div className='flex w-full flex-wrap'>
        <div className={`grid w-full grid-cols-3 gap-[36px]`}>
          {banner &&
            banner.slice(0, 3).map((e, index) => (
              <div className='block' key={index}>
                <Link
                  href={e.link || '/'}
                  className='block h-full w-full overflow-hidden rounded outline-none'
                >
                  <ImageOptimize
                    src={e.image}
                    alt={getTranslate(e.title)}
                    className='h-full w-full object-cover'
                    loading='lazy'
                  />
                </Link>
              </div>
            ))}
        </div>
      </div>
    )
  }, [layout])

  const layoutFour = useMemo(() => {
    return (
      <div className='grid w-full grid-cols-4 gap-3'>
        {banner &&
          banner.slice(0, 4).map((e, index) => (
            <div className='' key={index}>
              <Link
                href={e.link || '/'}
                className='block h-full w-full overflow-hidden rounded outline-none'
              >
                <ImageOptimize
                  src={e?.image}
                  alt={getTranslate(e.title)}
                  className='h-auto w-full object-cover'
                  loading='lazy'
                />
              </Link>
            </div>
          ))}
      </div>
    )
  }, [layout])

  const layoutFive = useMemo(() => {
    return (
      <>
        <div className='grid w-full grid-cols-4 gap-4 pb-4'>
          {banner &&
            banner.slice(0, 4).map((e, index) => (
              <div className='' key={index}>
                <Link
                  href={e.link || '/'}
                  className='block h-full w-full overflow-hidden rounded outline-none'
                >
                  <ImageOptimize
                    src={e?.image}
                    alt={getTranslate(e.title)}
                    className='h-auto w-full object-cover'
                    loading='lazy'
                  />
                </Link>
              </div>
            ))}
        </div>
        <div className='grid w-full grid-cols-3 gap-4 pb-4'>
          {banner &&
            banner.slice(4, 7).map((e, index) => (
              <div className='' key={index}>
                <Link
                  href={e.link || '/'}
                  className='block h-full w-full overflow-hidden rounded outline-none'
                >
                  <ImageOptimize
                    src={e?.image}
                    alt={getTranslate(e.title)}
                    className='h-auto w-full object-cover'
                    loading='lazy'
                  />
                </Link>
              </div>
            ))}
        </div>
      </>
    )
  }, [layout])

  const checkLayoutBanner = () => {
    switch (layout) {
      case 1:
        return layoutOne
        break
      case 2:
        return layoutTwo
        break
      case 3:
        return layoutThree
        break
      case 4:
        return layoutFour
        break
      case 5:
        return layoutFive
        break
      default:
        return layoutOne
        break
    }
  }

  
return (
    <>
      {banner && (
        <div className={`pb-4`}>
          <>{checkLayoutBanner()}</>
        </div>
      )}
    </>
  )
}

export default HomeBanner
